import axios, { AxiosResponse } from 'axios';
import { getApiLink } from '../api';
import { useData } from '../hooks/useData';

async function getRecentSearches(): Promise<string[]> {
	const response: AxiosResponse<string[]> = await axios.get(
		getApiLink('SearchHistory/GetRecentSearches')
	);

	return response.data;
}

export default function useRecentSearches() {
	return useData([], getRecentSearches);
}